export default function MobileService($window) {
  'ngInject';
  return {
    isMobile: function () {
      return $window.innerWidth < 768;
    }
  };
}